export default __webpack_public_path__ + "static/media/stand_4.16263153.jpg";